import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import * as MT from "./mutation-types";
import * as AC from "./action-types";
import { users } from "./mock-user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    userIsAdmin: false,
  },
  mutations: {
    [MT.AUTH_UPDATE_USER]: (state, user) => {
      state.user = user;
    },
    [MT.AUTH_LOGOUT]: (state) => {
      state.user = null;
    },
    [MT.UPDATE_ADMIN_STATUS]: (state, user) => {
      state.userIsAdmin = user.ID === 1;
    },
  },
  actions: {
    [AC.AUTH_DO_LOGIN]({ commit }, credentials) {
      let credsFound = false;
      if (credentials) {
        for (let i = 0; i < users.length; i++) {
          if (
            users[i].UserName == credentials.username &&
            users[i].Password == credentials.password
          ) {
            credsFound = true;
            commit(MT.AUTH_UPDATE_USER, users[i]);
            commit(MT.UPDATE_ADMIN_STATUS, users[i]);
            localStorage.setItem("userIsAdmin", users[i].ID == 1);
            localStorage.setItem("user", users[i]);
            router.push("/");
          }
        }
        if (!credsFound) {
          console.log("Wrong Credentials");
        }
      } else {
        commit(MT.AUTH_UPDATE_USER, null);
        console.log("User can not be empty");
      }
    },

    // Performs user log out
    [AC.AUTH_DO_LOGOUT]({ commit }) {
      localStorage.removeItem("user");
      localStorage.removeItem("userIsAdmin");
      commit(MT.AUTH_UPDATE_USER, null);
      commit(MT.AUTH_LOGOUT);
      window.location.reload();
    },
  },
});
